import createInboxAccountForm from './createInboxAccount'
import checkoutForm from './checkoutForm'
import freeProductForm from './freeProductForm'
import registerPersonIdForm from './registerPersonIdForm'
import addPersonIdForm from './addPersonIdForm'
import addInboxAccountForm from './addInboxAccountForm'
import companyInformationForm from "./companyInformationForm";
import companyContactInformationForm from "./companyContactInformationForm";
import contactInformationForm from "./contactInformationForm";
import ticsForm from "./ticsForm";
import reportForm from "./reportForm";
import ticketAuthForm from "./ticketAuthForm";
import faqVoteForm from "./faqvoteForm";

export default {
    "create-inbox-account": createInboxAccountForm,
    "checkout-form": checkoutForm,
    "free-product-form": freeProductForm, 
    "register-personid-form": registerPersonIdForm,
    "add-personid-form": addPersonIdForm,
    "add-inbox-account-form": addInboxAccountForm,
    "company-information-form": companyInformationForm,
    "company-contact-information-form": companyContactInformationForm,
    "contact-information-form": contactInformationForm,
    "tics-form": ticsForm,
    "report-form": reportForm,
    "ticketauth-form": ticketAuthForm,
    "faqvote-form": faqVoteForm
}  